<template>
  <div class="group-list">
    <div class="list-table__title">Group list</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="groups"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #cell(Class)="group">
        <div>{{group.item | className}}</div>
      </template>
      <template #cell(Details)="group">
        <div>
          <div>
            <b-button
              pill
              variant="outline-secondary"
              :to="{name: 'GroupEdit', params: { groupId: group.item.id }}"
              class="w-100 min-width-initial"
            >
              Details
            </b-button>
          </div>
        </div>
      </template>
    </b-table>
    <div v-if="groups.length === 0" class="no-data">
      <p>No Data Available</p>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import DetailButton from '@/components/parts/DetailBtn.vue';
import { Group } from '@/store/groups/types';
import { RootState } from '@/store/types';
import { Weekdays } from '@/store/common.types';

@Component({
  components: {
    DetailButton,
  },
  filters: {
    className(group: Group) {
      return `${group.fiscalYear}.${group.semester.name}.${Weekdays[group.dayOfWeek]}.${group.period}`
    },
  },
})
export default class GroupList extends Vue {
  private fields: Array<Object> = [
    {
      key: 'tutor.id',
      label: 'Tutor ID',
    },
    {
      key: 'tutor.name',
      label: 'Tutor Name',
    },
    {
      key: 'university.name',
      label: 'University',
    },
    {
      key: 'campus.name',
      label: 'Campus',
    },
    { key: 'Class' },
    {
      key: 'courseCode',
      label: 'Course Code',
    },
    {
      key: 'studentsCount',
      label: 'Students',
    },
    { key: 'Details' },
  ]

  private get groups(): Group[] {
    return (this.$store.state as RootState).groups.groups
  }
}
</script>

<style>
.group-list .list-table .list-table__head th {
  font-size: .6rem;
  vertical-align: middle;
  white-space: pre-line;
}

.group-list .list-table .list-table__body td {
  font-size: .5rem;
  padding: 1rem .5rem;
}
.group-list .list-table .list-table__body td[aria-colindex="6"] {
  overflow-wrap:break-word;
}
</style>
